import * as Yup from "yup";

export const documentNumberSchema = (documentType: string, countryCode = 'FRA') => {
    switch (documentType) {
        case 'passport':
            switch (countryCode) {
                case 'FRA':
                    return Yup.string()
                        .length(9, 'Le numéro de passeport doit être de 9 caractères')
                        .matches(/^\d{2}[A-Za-z]{2}\d{5}$/, 'Le format doit être : 2 chiffres, 2 lettres, 5 chiffres')
                        .required('Ce champ est requis');
                case 'DEU':
                    return Yup.string()
                        .matches(/^[CFGHJK][A-Za-z0-9]{8}$/, 'Format : 1 lettre (C, F, G, H, J, K) suivie de 8 alphanumériques')
                        .required('Ce champ est requis');
                case 'ESP':
                    return Yup.string()
                        .matches(/^(\d{2}|[A-Za-z]{2})[A-Z0-9]{7}$/, 'Format : 2 lettres ou chiffres suivis de 7 alphanumériques')
                        .required('Ce champ est requis');
                case 'ITA':
                    return Yup.string()
                        .matches(/^[A-Za-z0-9]{2}\d{7}$/, 'Format : 2 alphanumériques suivis de 7 chiffres')
                        .required('Ce champ est requis');
                case 'BEL':
                    return Yup.string()
                        .matches(/^[A-Za-z]{2}\d{6}$/, 'Format : 2 lettres suivies de 6 chiffres')
                        .required('Ce champ est requis');
                case 'GRC':
                    return Yup.string()
                        .matches(/^[A-Za-z]{2}\d{7}$/, 'Format : 2 lettres suivies de 7 chiffres')
                        .required('Ce champ est requis');
                case 'LTU':
                    return Yup.string()
                        .matches(/^[A-Za-z0-9]{8}$/, 'Format : 8 alphanumériques')
                        .required('Ce champ est requis');
                case 'NLD':
                    return Yup.string()
                        .matches(/^[A-Za-z0-9]{9}$/, 'Format : 9 alphanumériques')
                        .required('Ce champ est requis');
                default:
                    return Yup.string().min(6).required('Ce champ est requis');
            }

        case 'id_card':
            switch (countryCode) {
                case 'FRA':
                    return Yup.string()
                        .matches(/^\d{12}$|^[A-Za-z0-9]{9}$|^[A-Za-z0-9]{12}$/, '12 chiffres, ou 9/12 alphanumériques')
                        .required('Ce champ est requis');
                case 'DEU':
                    return Yup.string()
                        .matches(/^\d{10}$|^[A-Za-z0-9]{11}$/, 'Format : 10 chiffres ou 11 alphanumériques')
                        .required('Ce champ est requis');
                case 'ESP':
                    return Yup.string()
                        .matches(/^\d{8}[A-Za-z]$|^\d{8}-[A-Za-z]$|^\d{8} [A-Za-z]$/, 'Format : 8 chiffres + 1 lettre (avec ou sans séparateur)')
                        .required('Ce champ est requis');
                case 'ITA':
                    return Yup.string()
                        .matches(/^[A-Za-z0-9]{16}$/, 'Format : 16 alphanumériques')
                        .required('Ce champ est requis');
                case 'BEL':
                    return Yup.string()
                        .matches(/^\d{11}$/, 'Format : 11 chiffres')
                        .required('Ce champ est requis');
                case 'GRC':
                    return Yup.string()
                        .matches(/^([A-Za-z]{1,2}-?\d{6})$/, 'Format : 1-2 lettres, séparateur optionnel, 6 chiffres')
                        .required('Ce champ est requis');
                case 'POL':
                    return Yup.string()
                        .matches(/^\d{11}$/, 'Format : 11 chiffres')
                        .required('Ce champ est requis');
                case 'NLD':
                    return Yup.string()
                        .matches(/^\d{8,9}$/, 'Format : 8 ou 9 chiffres')
                        .required('Ce champ est requis');
                case 'DNK':
                    return Yup.string()
                        .matches(/^\d{10}$|^\d{6}-\d{4}$|^\d{6} \d{4}$/, 'Format : 10 chiffres ou 6+4 avec séparateur')
                        .required('Ce champ est requis');
                default:
                    return Yup.string().min(6).required('Ce champ est requis');
            }

        case 'driver_permit':
            switch (countryCode) {
                case 'FRA':
                    return Yup.string()
                        .length(12, 'Doit comporter 12 chiffres')
                        .matches(/^\d{12}$/, 'Format : uniquement 12 chiffres')
                        .required('Ce champ est requis');
                case 'DEU':
                    return Yup.string()
                        .matches(/^[A-Za-z]\d{2}[A-Za-z0-9]{6}\d$/, 'Format : Lettre, 2 chiffres, 6 alphanum, 1 chiffre')
                        .required('Ce champ est requis');
                case 'BEL':
                    return Yup.string()
                        .matches(/^\d{10}$/, 'Format : 10 chiffres')
                        .required('Ce champ est requis');
                case 'PRT':
                    return Yup.string()
                        .matches(/^[A-Za-z]{1,2}-\d{5,7} \d$/, 'Format : 1-2 lettres, 5-7 chiffres, 1 chiffre après espace')
                        .required('Ce champ est requis');
                case 'AUT':
                    return Yup.string()
                        .matches(/^\d{8}$/, 'Format : 8 chiffres')
                        .required('Ce champ est requis');
                case 'GRC':
                    return Yup.string()
                        .matches(/^\d{9}$/, 'Format : 9 chiffres')
                        .required('Ce champ est requis');
                default:
                    return Yup.string().min(6).required('Ce champ est requis');
            }

        case 'residency_permit':
            return Yup.string()
                .min(9)
                .max(10)
                .matches(/^\d+$/, 'Veuillez entrer uniquement des chiffres')
                .required('Ce champ est requis');

        default:
            return Yup.string().min(9).required('Ce champ est requis');
    }
};